const MOBILE_QUERY = '(max-width: 749px)';

// Custom hero videos ship with `<source data-src>` instead of `src` so only the
// viewport-matching video is ever downloaded — the other one is skipped entirely.
const assignActiveSource = (video) => {
  const source = video.querySelector('source[data-src]');
  if (!source || source.src) return;
  source.src = source.dataset.src;
  video.load();
};

const isMobile = window.matchMedia(MOBILE_QUERY).matches;
document.querySelectorAll(isMobile ? '.hero__video--mobile' : '.hero__video--desktop').forEach(assignActiveSource);

const attach = (wrapper) => {
  const video = wrapper.querySelector('.hero__video--mobile');
  const button = wrapper.querySelector('.hero__video-fallback-play');
  if (!video || !button) return;
  // No active source on this viewport (e.g. desktop, where the mobile video was
  // intentionally left unloaded) — nothing to attempt playing.
  if (!video.querySelector('source')?.getAttribute('src')) return;

  const showButton = () => {
    button.hidden = false;
  };

  const hideButton = () => {
    button.hidden = true;
  };

  const attemptPlay = () => {
    const playPromise = video.play();
    if (playPromise && typeof playPromise.catch === 'function') {
      playPromise.catch(showButton);
    }
  };

  // Only attempt play() once the browser actually has data to play — calling
  // it earlier races the native `autoplay` attribute and can spuriously
  // reject on WebKit even when autoplay itself goes on to succeed.
  const checkAutoplay = () => {
    if (video.paused) attemptPlay();
  };

  if (video.readyState >= 2) {
    checkAutoplay();
  } else {
    video.addEventListener('loadeddata', checkAutoplay, { once: true });
  }

  video.addEventListener('playing', hideButton);
  button.addEventListener('click', attemptPlay);
};

document.querySelectorAll('.hero__video-wrapper--mobile').forEach(attach);
